/** Session marker set before leaving for a PSP checkout (cross-site redirect). */
export const PSP_RETURN_PENDING_KEY = 'cse:psp-return-pending'

export type PspReturnContext = {
  module: string
  returnPath: string
  entityId?: string
}

export function markPspReturnPending(context: PspReturnContext): void {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  try {
    sessionStorage.setItem(PSP_RETURN_PENDING_KEY, JSON.stringify({ ...context, at: Date.now() }))
  } catch {
    // ignore quota / private mode
  }
}

export function readPspReturnPending(): PspReturnContext | null {
  if (typeof sessionStorage === 'undefined') {
    return null
  }
  try {
    const raw = sessionStorage.getItem(PSP_RETURN_PENDING_KEY)
    if (raw === null || raw === '') {
      return null
    }
    const parsed = JSON.parse(raw) as Partial<PspReturnContext>
    if (typeof parsed.returnPath !== 'string' || typeof parsed.module !== 'string') {
      return null
    }
    return {
      module: parsed.module,
      returnPath: parsed.returnPath,
      entityId: typeof parsed.entityId === 'string' ? parsed.entityId : undefined,
    }
  } catch {
    return null
  }
}

export function clearPspReturnPending(): void {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  try {
    sessionStorage.removeItem(PSP_RETURN_PENDING_KEY)
  } catch {
    // ignore
  }
}
